import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { getUser } from "./user";
import * as signalR from "@microsoft/signalr";

interface IPropsConectSocket {
  url: string;
  hub: string;
  descriptionConnection?: string;
  cb: any;
  params?: Record<string, string | number>;
  apiKey?: string | null | undefined;
}

const connectSocket = function <T>({
  url,
  hub,
  descriptionConnection = "Conexão estabelecida com sucesso",
  cb,
  apiKey,
}: IPropsConectSocket) {
  const connection = new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_SOCKET}/${url}`, {
      accessTokenFactory: () => apiKey || getUser()?.token || "",
    })
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect()
    .build();

  connection.on(hub, (data: T) => cb(data));

  connection
    .start()
    .then(() => {
      console.log("Conexão com SignalR estabelecida com sucesso!");
    })
    .catch((err) => {
      console.error("Falha ao conectar com SignalR: ", err);
    });
  return connection;
};

export default connectSocket;
